import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-wr" }
const _hoisted_2 = { class: "loading-wr" }
const _hoisted_3 = { class: "house-preview" }
const _hoisted_4 = { class: "house-floorplans" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.builder && !$setup.loading)
      ? (_openBlock(), _createBlock($setup["BuilderEstimatorMobileHeader"], {
          key: 0,
          currentStep: $setup.currentStep,
          builder: $setup.builder,
          totalPrice: $setup.calculateTotalPrice,
          onToggleSummaryModal: $setup.toggleSummaryModal
        }, null, 8, ["currentStep", "builder", "totalPrice"]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_2, [...(_cache[4] || (_cache[4] = [
      _createElementVNode("div", { class: "spinner" }, null, -1)
    ]))], 512), [
      [_vShow, $setup.loading || !$setup.builder]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _withDirectives(_createVNode($setup["BuilderEstimatorToolHero"], {
        preferredLocation: _ctx.preferredLocation,
        "onUpdate:preferredLocation": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.preferredLocation) = $event)),
        landWidth: _ctx.landWidth,
        "onUpdate:landWidth": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.landWidth) = $event)),
        landDepth: _ctx.landDepth,
        "onUpdate:landDepth": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.landDepth) = $event)),
        builderLogo: $setup.builder?.logo,
        "onUpdate:landFilter": _cache[3] || (_cache[3] = ($event: any) => ($setup.onSelectLandDetails($event)))
      }, null, 8, ["preferredLocation", "landWidth", "landDepth", "builderLogo"]), [
        [_vShow, $setup.currentStep === $setup.BuilderEstimatorSteps.LAND_DETAILS]
      ]),
      ($setup.currentStep === $setup.BuilderEstimatorSteps.VIEW_DESIGN && !$setup.houseDesign)
        ? (_openBlock(), _createBlock($setup["HousesDesignsGrid"], {
            key: 0,
            houses: $setup.houses,
            updateSelectHouseDesign: $setup.onViewDesignSelect,
            onOnNotHousesFound: $setup.onNotHousesFound
          }, null, 8, ["houses", "updateSelectHouseDesign"]))
        : _createCommentVNode("", true),
      ($setup.currentStep === $setup.BuilderEstimatorSteps.SELECT_DESIGN && $setup.houseDesign)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["house-details-layout", { 'desktop-wrapper': $setup.isDesktop }])
          }, [
            (!$setup.isDesktop)
              ? (_openBlock(), _createBlock($setup["BuilderEstimatorHouseHeaderMobile"], {
                  key: 0,
                  houseName: $setup.houseDesign?.name,
                  features: $setup.houseDesign,
                  onBack: $setup.onSelectPrev
                }, null, 8, ["houseName", "features"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
              _createVNode($setup["BuilderEstimatorSelectionHouse"], {
                selectedHouseDesign: $setup.houseDesign,
                selectedBuilder: $setup.builder,
                onBack: $setup.onSelectPrev,
                "onUpdate:selectHouseDesign": $setup.onSelectHouseDesign
              }, null, 8, ["selectedHouseDesign", "selectedBuilder", "onUpdate:selectHouseDesign"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode($setup["BuilderEstimatorFloorplans"], { houseDesign: $setup.houseDesign }, null, 8, ["houseDesign"])
            ])
          ], 2))
        : _createCommentVNode("", true),
      ($setup.currentStep === $setup.BuilderEstimatorSteps.SELECT_FACADE)
        ? (_openBlock(), _createBlock($setup["BuilderEstimatorSelectionHouseStyle"], {
            key: 2,
            sliderOptions: $setup.sortByPriceAscending($setup.mapFacadeImages($setup.houseDesign?.facades || [])),
            selectedHouseStyle: $setup.formData[$setup.BuilderEstimatorSteps.SELECT_FACADE].facade,
            instructions: $setup.SELECTION_HOUSE_STYLE_INSTRUCTIONS.facade,
            onOnSelectOptionStyle: $setup.handleOptionStyle
          }, null, 8, ["sliderOptions", "selectedHouseStyle", "instructions"]))
        : _createCommentVNode("", true),
      ($setup.currentStep === $setup.BuilderEstimatorSteps.SELECT_EXTERNAL_COLOURS)
        ? (_openBlock(), _createBlock($setup["BuilderEstimatorSelectionHouseStyle"], {
            key: 3,
            sliderOptions: $setup.sortByPriceAscending($setup.formData[$setup.BuilderEstimatorSteps.SELECT_FACADE]?.facade?.externalColorSchemes || []),
            instructions: $setup.SELECTION_HOUSE_STYLE_INSTRUCTIONS.externalColours,
            selectedHouseStyle: $setup.formData[$setup.BuilderEstimatorSteps.SELECT_EXTERNAL_COLOURS].externalColorScheme,
            onOnSelectOptionStyle: $setup.handleOptionStyle
          }, null, 8, ["sliderOptions", "instructions", "selectedHouseStyle"]))
        : _createCommentVNode("", true),
      ($setup.currentStep === $setup.BuilderEstimatorSteps.SELECT_INTERNAL_COLOURS)
        ? (_openBlock(), _createBlock($setup["BuilderEstimatorSelectionHouseStyle"], {
            key: 4,
            sliderOptions: $setup.sortByPriceAscending($setup.houseDesign?.internalColorSchemes || []),
            instructions: $setup.SELECTION_HOUSE_STYLE_INSTRUCTIONS.internalColours,
            selectedHouseStyle: $setup.formData[$setup.BuilderEstimatorSteps.SELECT_INTERNAL_COLOURS].internalColorScheme,
            onOnSelectOptionStyle: $setup.handleOptionStyle,
            isInternalColor: true
          }, null, 8, ["sliderOptions", "instructions", "selectedHouseStyle"]))
        : _createCommentVNode("", true),
      ($setup.currentStep === $setup.BuilderEstimatorSteps.SELECT_INCLUSIONS)
        ? (_openBlock(), _createBlock($setup["BuilderEstimatorInclusionsPack"], {
            key: 5,
            inclusionPackages: $setup.houseDesign?.inclusionPack || [],
            selectedInclusionPack: $setup.formData[$setup.BuilderEstimatorSteps.SELECT_INCLUSIONS].inclusionPack,
            onOnSelectInclusionPack: $setup.onSelectInclusionPack
          }, null, 8, ["inclusionPackages", "selectedInclusionPack", "onOnSelectInclusionPack"]))
        : _createCommentVNode("", true),
      ($setup.currentStep === $setup.BuilderEstimatorSteps.OPTIONAL_UPGRADES)
        ? (_openBlock(), _createBlock($setup["BuilderEstimatorHouseUpgradeOption"], {
            key: 6,
            optionalUpgrades: $setup.houseDesign?.optionalUpgrades || [],
            selectedUpgradeFromForm: $setup.formData[$setup.BuilderEstimatorSteps.OPTIONAL_UPGRADES].optionalUpgrades,
            onOnSelectOptionalUpgrade: $setup.onSelectOptionalUpgrade
          }, null, 8, ["optionalUpgrades", "selectedUpgradeFromForm", "onOnSelectOptionalUpgrade"]))
        : _createCommentVNode("", true),
      _createVNode($setup["BuilderEstimatorQuoterSummary"], {
        isOpen: $setup.summaryModalIsOpen,
        formData: $setup.formData,
        totalPrice: $setup.calculateTotalPrice,
        "onUpdate:isOpen": $setup.updateSummaryModalState
      }, null, 8, ["isOpen", "formData", "totalPrice"]),
      ($setup.currentStep === $setup.BuilderEstimatorSteps.SUMMARY)
        ? (_openBlock(), _createBlock($setup["BuilderEstimatorSummary"], {
            key: 7,
            "builder-logo": $setup.builder?.logo,
            "form-data": $setup.formData,
            "total-price": $setup.calculateTotalPrice,
            onSelectPrev: $setup.onSelectPrev
          }, null, 8, ["builder-logo", "form-data", "total-price"]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, !$setup.loading && $setup.builder]
    ]),
    (!$setup.loading && $setup.builder && $setup.currentStep !== $setup.BuilderEstimatorSteps.SUMMARY)
      ? (_openBlock(), _createBlock($setup["BuilderStepNavigationContainer"], {
          key: 1,
          builderLogo: $setup.builder?.logo,
          builderColor: $setup.builder?.color,
          steps: $setup.availableBuilderSteps,
          currentStep: $setup.currentStep,
          totalPrice: $setup.calculateTotalPrice,
          errorOnCurrentStep: $setup.errorOnCurrentStep,
          houseDesign: $setup.houseDesign,
          onSelectNext: $setup.onSelectNext,
          onSelectPrev: $setup.onSelectPrev,
          onToggleSummaryModal: $setup.toggleSummaryModal
        }, null, 8, ["builderLogo", "builderColor", "steps", "currentStep", "totalPrice", "errorOnCurrentStep", "houseDesign"]))
      : _createCommentVNode("", true)
  ]))
}